module.exports = __webpack_public_path__ + "static/media/checkin.da78cad3.svg";